import React from "react"

import { FiChevronsRight, FiChevronsLeft } from "react-icons/fi"

const Pagination = ({ engine, className, align = "left" }) => (
  <div className={className} data-align={align}>
    {engine.filteredEntries().length > engine.state.limit
      && engine.state.collapsed && (
        <>
          <div data-previous onClick={() => engine.previousPage()}>
            <FiChevronsLeft />
          </div>
          {[...Array(engine.numberOfPages())].map((_, index) => (
            <div
              key={index}
              data-current={engine.currentPageNumber() === index}
              data-index
              onClick={() => engine.setCurrentPage(index)}
            >
              {index + 1}
            </div>
          ))}
          <div data-next onClick={() => engine.nextPage()}>
            <FiChevronsRight />
          </div>
        </>
    )}
  </div>
)

export default Pagination
